import auth from "../../firebase/auth";
import { Link } from "react-router-dom";
import { Outlet } from "react-router-dom";
import SpinnerDot from "../../components/SpinnerDot";
import useAxiosJwtQuery from "../../hooks/useAxiosJwtQuery";

const SideNavLink = (props) => {
  return (
    <li>
      <Link
        className={`hover:decoration-wavy hover:decoration-blue-400 hover:underline-offset-8`}
        {...props}
      />
    </li>
  );
};

export default function Dashboard() {
  const { email } = auth.currentUser;

  const [user] = useAxiosJwtQuery(`/users/${email}`);

  return (
    <main>
      <div class="drawer drawer-mobile h-auto">
        <input id="my-drawer-2" type="checkbox" class="drawer-toggle" />

        <div class="drawer-content flex flex-col items-center justify-center p-8">
          <label
            for="my-drawer-2"
            class="btn btn-primary drawer-button lg:hidden w-64 my-4 text-lg"
          >
            Menu
          </label>

          <section className="text-center w-full">
            <h1>Welcome to The Dashboard</h1>

            <Outlet />
          </section>
        </div>

        <div class="drawer-side">
          <label for="my-drawer-2" class="drawer-overlay"></label>

          <ul class="menu p-4 overflow-y-auto w-80 bg-base-100 text-base-content">
            {!user ? (
              <SpinnerDot />
            ) : (
              (() => {
                const isAdmin = user.admin === true;

                return isAdmin ? (
                  <>
                    <SideNavLink to="" children="My Profile" />
                    <SideNavLink to="add-product" children="Add Product" />
                    <SideNavLink to="manage-users" children="Manage Users" />
                    <SideNavLink to="manage-orders" children="Manage Orders" />
                    <SideNavLink to="manage-products" children="Manage Products" />
                  </>
                ) : (
                  <>
                    <SideNavLink to="" children="My Profile" />
                    <SideNavLink to="my-orders" children="My Orders" />
                    <SideNavLink to="add-review" children="Add Review" />
                  </>
                );
              })()
            )}
          </ul>
        </div>
      </div>
    </main>
  );
}
